/* eslint-disable complexity */
// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

import { UNSAFE_media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import {
    ContentBlock,
    OneLinkProps
} from "../../../../components/wpl/content-block/src";
import { Link } from "../../../../components/wpl/link/src";
import {
    TabGroup,
    IndividualTabPropsCustom,
    TabColorProps
} from "../../../../components/wpl/tab-group/src";
import {
    Row,
    BGProps,
    BGStyles,
    ProductKeyTypes
} from "../../../../libraries/wpl/foundations/src";

export interface PatternTabsCustomProps {
    id: string;
    label: string;
    headerText: string;
    bodyText: string;
    tabs: IndividualTabPropsCustom[];
    dataProductKey: ProductKeyTypes;
    colors?: TabColorProps;
    ctaProps?: OneLinkProps;
    linkPosition?: "top" | "bottom";
    backgroundProperties?: BGProps;
    className?: string;
}

const CustomTabsStyle = css`
    padding: ${token("space.800")} 0;

    ${UNSAFE_media.only.sm} {
        padding: ${token("space.600")} 0;
    }

    ${UNSAFE_media.below.sm} {
        padding: ${token("space.400")} 0;
    }
`;

export const TabsCustom = ({
    id,
    label,
    headerText,
    bodyText,
    tabs,
    dataProductKey,
    colors,
    ctaProps,
    linkPosition = "bottom",
    backgroundProperties,
    className
}: PatternTabsCustomProps) => {
    return (
        <div
            className={className}
            css={[BGStyles(backgroundProperties), CustomTabsStyle]}
        >
            {/*<Row layout="reduced">*/}
            <Row>
                <ContentBlock
                    headerText={headerText}
                    headerType="h2"
                    bodyText={bodyText}
                    isCentered={true}
                    ctaProps={
                        linkPosition == "top" && ctaProps?.primaryLinkProps
                            ? ctaProps
                            : {}
                    }
                />
            </Row>

            <div>
                <TabGroup
                    colors={colors}
                    tabContentType="custom"
                    tabs={tabs}
                    id={id}
                    label={label}
                    dataProductKey={dataProductKey}
                />
            </div>

            {linkPosition == "bottom" && ctaProps?.primaryLinkProps ? (
                <Row>
                    <div style={{ textAlign: "center" }}>
                        <Link {...ctaProps.primaryLinkProps} />
                    </div>
                </Row>
            ) : null}
        </div>
    );
};
